// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination[data-v-39bf0698] {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n[data-v-39bf0698] .el-pagination.is-background .el-pager li:not(.disabled).active {\n  color: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
